<div> 
    <div class="ttmodal__header">
        <span class="ttmodal__title" style="font-size: 20px;">{{'Warranty Status' | translate | async}}</span>
        <i class="material-icons ttmodal__close-button" style="margin-left: 60%; cursor: pointer;" (click)="onCloseClick()">close</i>
    </div>
    <div class="ttmodal__body">

      <!-- <div *ngIf="isAdmin">
        <a (click)="showWarrantySetup()" *ngIf="!showIsAdminWarrantyInfo" >
          <i class="material-icons square-button__icon" style="transform: scale(1) rotate( 90deg);margin-left: 94%; cursor: pointer;">forward</i></a>
          <a (click)="showWarrantySetup()" *ngIf="showIsAdminWarrantyInfo">
            <i class="material-icons square-button__icon" style="transform: scale(1) rotate( 270deg); margin-left: 94%; cursor: pointer;">forward</i></a>
      </div> -->

    <div *ngIf="isAdmin" style="margin-top: 4%;">
     

       <mat-accordion>

        <mat-expansion-panel (opened)="panelOpenState = true"
                             (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{'Add New' | translate | async}}
            </mat-panel-title>        
          </mat-expansion-panel-header>
          
            <div class="input-container">
              <span class="labelNew">{{'Select Warranty Type' | translate | async}}</span>
              <select class="get-Input"  style="margin-left: 4%;" [(ngModel)]="WarrantyType" required>          
                  <option *ngFor="let type of warrantyList" [value]="type.ID">{{type.Type}}</option>
              </select>
             </div>
             
           <div class="input-container">
              <span class="labelNew">{{'Select Start Date' | translate | async}}</span>    
              <input type="text" [matDatepicker]="picker" class="get-Input-date" 
               placeholder="Choose a date"
               [(ngModel)]="startDate" (ngModelChange)="dateChanged()"
               readonly="readonly" style="color: black;margin-left: 10%;" required  [disabled]="showUpdateButton">
               <span class="input-icon input-icon--mat cursor-pointer get-date-icon" (click)="picker.open()">
                <i class="material-icons">date_range</i>
             </span>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <div class="input-container" *ngIf="!showImplementStatusModal">
            <span class="labelNew">{{'Enter Starting SMU' | translate | async}}</span>
            <input type="number" class="get-Input" style="margin-left: 6.5%;" value="0" min="0" [(ngModel)]="startSmu" required/>
            <span class="input-icon get-icon">Hrs</span>
          </div>

          <div class="input-container">
            <span class="labelNew">{{'Enter Starting Cycle #' | translate | async}}</span>
            <input type="number" class="get-Input" style="margin-left: 3%;" value="0" min="0" [(ngModel)]="startCycle" />
            <!-- <span class="input-icon get-icon">Hrs</span> -->
          </div>

          <div class="ttmodal__footer" style="margin-left: 60%;">
            <a class="button button--primary" *ngIf="!showUpdateButton &&  showImplementStatusModal==false" (click)="UpdateWithDefault()"  ><span class="button__text">{{'Set Default' | translate | async}}</span></a>
           <a class="button button--primary" *ngIf="showUpdateButton" (click)="Update()"  ><span class="button__text">{{'Update' | translate | async}}</span></a>
           <a class="button button--primary" *ngIf="!showUpdateButton" (click)="Update()" ><span class="button__text">{{'Save' | translate | async}}</span></a>
          </div>

         

     
        </mat-expansion-panel>
      </mat-accordion>
       
  </div>
     
  <!-- for Equipment -->
       <div *ngIf="!showImplementStatusModal">

       
        <div class="input-container">
          <span class="label">{{'Warranty Type' | translate | async}}</span>
          <span class="label">{{warrantyTypeName}}</span>
        </div>
        <div class="input-container">
          <span class="label" style="font-weight: 800;">{{'Original Warranty' | translate | async}}</span>
          <!-- <span class="label">status</span> -->
        </div>
        <div class="input-container">
          <span class="label">{{'Commencement Date' | translate | async}}</span>
          <span class="label">{{startDate| date:'dd MMM yyyy'}}</span>
        </div>
        <div class="input-container" *ngIf="equipmentDetails != null">
          <span class="label">{{'Commencement SMU' | translate | async}}</span>
          <span class="label">{{startSmu}}</span>
        </div>

        <div class="input-container" *ngIf="equipmentDetails != null">
          <span class="label">{{'Original CMU' | translate | async}}</span>
          <span class="label">{{startCMU}}</span>
        </div>
        <div class="input-container">
          <table class="table table--full-width table--striped" style="margin-top: 9px;">      
            <thead>
              <tr>                
               <th>{{'Hours' | translate | async}}</th>
               <th>{{'Days' | translate | async}}</th>
               <th>{{'Cycles' | translate | async}}</th>              
              </tr>
            </thead>
            <tbody>    
              <tr>      
                  <td>{{WarrantyTypeIntialHours}}</td>  
                  <td>{{WarrantyTypeIntialDays}}</td>
                  <td>0</td>
              </tr>    
            </tbody>      
          </table>
        </div>
     
  
        <!-- <div style="margin-bottom: 25px;"></div> -->
        <div class="input-container">
          <span class="label" style="font-weight: 800;">{{'Residual Warranty' | translate | async}}</span>
         
        </div>
        <div class="input-container">
          <span class="label">{{'Current Date' | translate | async}}</span>
          <span class="label">{{currentDate| date:'dd MMM yyyy'}}</span>
        </div>
        <div class="input-container">
          <span class="label">{{'Current SMU' | translate | async}}</span>
          <span class="label">{{meterReading}}</span>
          </div>
          <div class="input-container">
            <span class="label">{{'Current CMU' | translate | async}}</span> 
            <span class="label">{{currentCMU}}</span>
            </div>
        <div class="input-container">
          <span class="label">{{'Current Cycles' | translate | async}}</span>
          <span class="label">0</span>
        </div>

        <div class="input-container">
          <table class="table table--full-width table--striped" style="margin-top: 9px;">      
            <thead>
              <tr>                
               <th>{{'Hours' | translate | async}}</th>
               <th>{{'Days' | translate | async}}</th>
               <th>{{'Cycles' | translate | async}}</th>              
              </tr>
            </thead>
            <tbody>    
              <tr>      
                  
                  <td> {{ResidualWarrantyHours >=0 ? ResidualWarrantyHours :0}}</td>
                  <td>{{WarrantyTypeResidualDays}}</td>
                  <td>0</td>
              </tr>    
            </tbody>      
          </table>
        </div>
  
      </div> 

       <!-- for Inventory -->
       <div *ngIf="showImplementStatusModal">

       
        <div class="input-container">
          <span class="label">{{'Warranty Type' | translate | async}}</span>
          <span class="label">{{warrantyTypeName}}</span>
        </div>
        <div class="input-container">
          <span class="label" style="font-weight: 800;">{{'Original Warranty' | translate | async}}</span>
          <!-- <span class="label">status</span> -->
        </div>
        <div class="input-container">
          <span class="label">{{'Commencement Date' | translate | async}}</span>
          <span class="label">{{startDate| date:'dd MMM yyyy'}}</span>
        </div>
        <!-- <div class="input-container" *ngIf="equipmentDetails != null">
          <span class="label">Commencement SMU</span>
          <span class="label">{{startSmu}}</span>
        </div> -->
        <div class="input-container">
          <table class="table table--full-width table--striped" style="margin-top: 9px;">      
            <thead>
              <tr>                
               <!-- <th>Hours</th> -->
               <th>{{'Days' | translate | async}}</th>
               <th>{{'Cycles' | translate | async}}</th>              
              </tr>
            </thead>
            <tbody>    
              <tr>      
                  <!-- <td>{{WarrantyTypeIntialHours}}</td>   -->
                  <td>{{WarrantyTypeIntialDays}}</td>
                  <td>0</td>
              </tr>    
            </tbody>      
          </table>
        </div>
     
  
        <!-- <div style="margin-bottom: 25px;"></div> -->
        <div class="input-container">
          <span class="label" style="font-weight: 800;">{{'Residual Warranty' | translate | async}}</span>
         
        </div>
        <div class="input-container">
          <span class="label">{{'Current Date' | translate | async}}</span>
          <span class="label">{{currentDate| date:'dd MMM yyyy'}}</span>
        </div>
        <!-- <div class="input-container">
          <span class="label">{{'Current SMU' | translate | async}}</span>
          <span class="label">{{meterReading}}</span>
          </div> -->
        <div class="input-container">
          <span class="label">{{'Current Cycles' | translate | async}}</span>
          <span class="label">0</span>
        </div>

        <div class="input-container">
          <table class="table table--full-width table--striped" style="margin-top: 9px;">      
            <thead>
              <tr>                
               <!-- <th>Hours</th> -->
               <th>{{'Days' | translate | async}}</th>
               <th>{{'Cycles' | translate | async}}</th>              
              </tr>
            </thead>
            <tbody>    
              <tr>      
                  <!-- <td>{{ResidualWarrantyHours}}</td> -->
                  <td>{{WarrantyTypeResidualDays}}</td>
                  <td>0</td>
              </tr>    
            </tbody>      
          </table>
        </div>
  
      </div>
    </div>
    
</div>